export default __webpack_public_path__ + "static/media/agency-tablet-main.4040219b.webp";